import { components } from "react-select";
import { ChevronDown, ChevronUp } from "react-feather";

const { DropdownIndicator } = components;

const CaretDownIcon = () => {
  return <ChevronUp size={15} style={{ marginTop: "-5px" }} />;
};

const CaretUpIcon = () => {
  return <ChevronDown size={15} style={{ marginTop: "-5px" }} />;
};

export const CustomDropdownIndicator = (props) => {
  const {
    selectProps: { menuIsOpen },
  } = props;
  return (
    <DropdownIndicator {...props}>
      {menuIsOpen ? <CaretDownIcon /> : <CaretUpIcon />}
    </DropdownIndicator>
  );
};
